// extracted by mini-css-extract-plugin
module.exports = {"section":"Form_section__14MrY","shareWithFriendsTitleStyle":"Form_shareWithFriendsTitleStyle__lhQTt","divider":"Form_divider__33Hte"};